// Shared CSV parsing utilities used by the export preview dialog.

/** Parse RFC-4180 CSV text, including quoted fields containing commas or newlines. */
export function parseCSVRows(text: string): string[][] {
  const rows: string[][] = []
  let row: string[] = []
  let cell = ""
  let inQuotes = false

  for (let i = 0; i < text.length; i++) {
    const ch = text[i]
    if (inQuotes) {
      if (ch === '"' && text[i + 1] === '"') {
        cell += '"'
        i++
      } else if (ch === '"') {
        inQuotes = false
      } else {
        cell += ch
      }
    } else if (ch === '"') {
      inQuotes = true
    } else if (ch === ",") {
      row.push(cell)
      cell = ""
    } else if (ch === "\r" && text[i + 1] === "\n") {
      row.push(cell)
      rows.push(row)
      row = []
      cell = ""
      i++
    } else if (ch === "\n" || ch === "\r") {
      row.push(cell)
      rows.push(row)
      row = []
      cell = ""
    } else {
      cell += ch
    }
  }

  if (cell.length > 0 || row.length > 0 || text.endsWith(",")) {
    row.push(cell)
    rows.push(row)
  }
  return rows
}

/** Parse a single RFC-4180 CSV record into an array of cell strings. */
export function parseCSVRow(line: string): string[] {
  return parseCSVRows(line)[0] ?? [""]
}

/** Escape a cell value for RFC-4180 CSV output. */
export function escapeCSVCell(value: string): string {
  return value.includes(",") || value.includes('"') || value.includes("\r") || value.includes("\n")
    ? `"${value.replace(/"/g, '""')}"`
    : value
}

/** Escape a string for HTML output (used in XLS generation). */
export function escapeHTML(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
}
